<!--  <kendo-dialog-actions>-->
<div class="custom-btn-group">
  <button kendoButton (click)="prev()" [disabled]="currentIndex === 0" class="btn btn-primary"><fa-icon
      icon="arrow-left"></fa-icon></button>
  <button kendoButton (click)="onConfirmComplete()" class="btn btn-danger" [disabled]="assessmentForm.invalid"
    *ngIf="!isDisabled">Complete</button>
  <button kendoButton (click)="onSaveAction()" class="btn btn-primary" *ngIf="!isDisabled">Save</button>
  <button kendoButton (click)="onCancelAction()" class="btn btn-secondary" *ngIf="!isDisabled">Cancel</button>
  <button kendoButton (click)="onCloseAction()" class="btn btn-secondary" *ngIf="isDisabled">Close</button>
  <button kendoButton (click)="next()" *ngIf="this.currentIndex < this.drawerItems.length - 1"
    [disabled]="currentIndex === drawerItems.length - 1" style="float:right" class="btn btn-primary"><fa-icon icon="arrow-right"></fa-icon></button>
</div>

<!--  </kendo-dialog-actions>-->
<div class="dialog-content-wrapper">

  <div class="custom-toolbar">
    <h3 class="index" (click)="drawer.toggle()">Index:</h3>
  </div>
  <kendo-drawer-container>
    <kendo-drawer #drawer [items]="drawerItems" mode="push" [expanded]="true" (select)="onSelect($event)"
      [autoCollapse]="false">
      <ng-template kendoDrawerItemTemplate let-item>
        <div class="drawer-item">
          <kendo-icon *ngIf="item.icon" [name]="item.icon" [ngClass]="getIconClass(item)"></kendo-icon>
          <span class="drawer-text">{{ item.text }}</span>
        </div>
      </ng-template>
    </kendo-drawer>

    <kendo-drawer-content>
      <form [formGroup]="assessmentForm" class="k-form-inline">

        <casi-assessment-introduction *ngIf="selectedItem.cssClass === 'introduction'" [assessment]="assessment"
          [assessmentForm]="assessmentForm"></casi-assessment-introduction>
        <casi-assessment-hours *ngIf="selectedItem.cssClass === 'hours'" [assessment]="assessment"
          [assessmentForm]="assessmentForm"></casi-assessment-hours>

        <div formArrayName="domains">
          <div *ngFor="let d of domainsArray.controls; let i = index" [formGroupName]="i">
            <casi-assessment-domain [domainForm]="d" [assessmentForm]="assessmentForm"
              (optOutChanged)="onOptOutChanged($event)"
              *ngIf="selectedItem.cssClass === 'domain' && selectedItem.id == d.get('assessment_domain_id')?.value"></casi-assessment-domain>
          </div>
        </div>

        <casi-assessment-additional-answer *ngIf="selectedItem.cssClass === 'additionalQuestion'"
          [assessment]="assessment" [assessmentForm]="assessmentForm"></casi-assessment-additional-answer>
      </form>

    </kendo-drawer-content>
  </kendo-drawer-container>

  <kendo-dialog-actions>
    <button kendoButton (click)="prev()" [disabled]="currentIndex === 0" class="btn btn-primary"><fa-icon
        icon="arrow-left"></fa-icon></button>
    <button kendoButton (click)="onConfirmComplete()" class="btn btn-danger" [disabled]="assessmentForm.invalid"
      *ngIf="!isDisabled">Complete</button>
    <button kendoButton (click)="onSaveAction()" class="btn btn-primary" *ngIf="!isDisabled">Save</button>
    <button kendoButton (click)="onCancelAction()" class="btn btn-secondary" *ngIf="!isDisabled">Cancel</button>
    <button kendoButton (click)="onCloseAction()" class="btn btn-secondary" *ngIf="isDisabled">Close</button>
    <button kendoButton (click)="next()" *ngIf="this.currentIndex < this.drawerItems.length - 1"
      [disabled]="currentIndex === drawerItems.length - 1" style="float:right" class="btn btn-primary"><fa-icon
        icon="arrow-right"></fa-icon></button>
  </kendo-dialog-actions>
</div>
